/** URL parameters: every screen and cave is reachable without clicking (docs/spec/06 §6). */

export const query = new URLSearchParams(location.search);

export function pick<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  const v = query.get(key);
  return allowed.includes(v as T) ? (v as T) : fallback;
}

export function num(key: string, fallback: number): number {
  const v = Number.parseFloat(query.get(key) ?? '');
  return Number.isFinite(v) ? v : fallback;
}
